import React from "react";
import { arrayOf, object } from "prop-types";

import PreconfigurationItem from "./PreconfigurationItem";

function SubMenu({ preconfigurationSubGroup }) {
  return (
    <ul
      className="
      text-white text-lg list-none font-light
      hidden self-start w-0 pl-5 absolute -right-5 -top-5
      group-hover:flex group-focus-within:flex
    "
    >
      <span className="px-8 py-5 bg-primaryDark/95 backdrop-blur-lg lg:rounded-sm cursor-default">
        {preconfigurationSubGroup.map((preconfiguration, index) => (
          <PreconfigurationItem
            index={index}
            key={index}
            label={preconfiguration.colorCode}
            singlePreconfiguration={preconfiguration}
          />
        ))}
      </span>
    </ul>
  );
}

SubMenu.propTypes = {
  preconfigurationSubGroup: arrayOf(object).isRequired,
};

export default SubMenu;
